import { render, staticRenderFns } from "./TheTextToSpeach.vue?vue&type=template&id=52e442ec&"
import script from "./TheTextToSpeach.vue?vue&type=script&lang=js&"
export * from "./TheTextToSpeach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports